// ======================= Imports =======================
import React, { useState, useEffect, useCallback } from "react";
import classNames from "classnames";
import { AppTopbar } from "./AppTopbar";
import { AppMenu } from "./AppMenu";
import { Route, Routes, useLocation, useNavigate } from "react-router-dom";
import ShippingQueue from "./app/features/screens/inventory_management/shipping_queue/shipping_queue";
import BillingModelConfigurations from "./app/features/screens/billingModel/billingmodel_configurations/billing_model_configurations";
import PostpaidEvaluatedEnrollments from "./app/features/screens/PostPaid-order/PostOrder-Screens/Evaluated_Enrollments";
import ClearDeviceReportFlowPage from "./app/features/screens/inventory_management/bulk_processes/clear_device_report/clear_esn_report_flow_page";
import AdvanceSearch from "./app/features/screens/search_customer/advance_search/advance_search";
import "primereact/resources/primereact.css";
import "primeicons/primeicons.css";
import "primeflex/primeflex.css";
import "prismjs/themes/prism-coy.css";
import "./assets/layout/layout.scss";
import "./app.css";
import AcpProgramsFlowPage from "./app/features/screens/company_acp_programs/acp_programs_flow_page";
import ServiceAvailablityPage from "./app/features/screens/eligiblityForEnrollment/pages/service_availblity_page";
import EnrollmentFlowPage from "./app/features/screens/eligiblityForEnrollment/pages/enrollment_flow_page";
import AllEnrollments from "./app/features/screens/lifeline_orders/AllEnrollments";
import ManageRolesAndRights from "./app/features/screens/roles_and_permissions/ManageRolesAndRights";
import ManageInventory from "./app/features/screens/inventory_management/manage-inventory/manage_inventory";
import CompletedEnrollments from "./app/features/screens/lifeline_orders/CompletedEnrollments";
import InCompletedEnrollments from "./app/features/screens/lifeline_orders/InCompleteEnrollments";
import RejectedEnrollments from "./app/features/screens/lifeline_orders/RejectedEnrolments";
import NLADResolutionStatus from "./app/features/screens/lifeline_orders/NLADResolutionStatus";
import HandoverEventOrder from "./app/features/screens/lifeline_orders/HandoverEventOrder";
import PendingEventOrder from "./app/features/screens/lifeline_orders/PendingEventOrder";
import WithProofEnrollments from "./app/features/screens/lifeline_orders/WithProofEnrollments";
import WithoutProofEnrollments from "./app/features/screens/lifeline_orders/WithoutProofEnrollments";
import DropshipOrdersFlowPage from "./app/features/screens/inventory_management/dropship_orders/dropship_orders_flow_page";

import Upload from "./app/features/screens/sms_notification/Upload";
import Sent from "./app/features/screens/sms_notification/Sent";
import Draft from "./app/features/screens/sms_notification/Draft";
import VerifyZip from "./app/features/screens/self_enrollment/VerifyZip";
import PersonalInfo from "./app/features/screens/self_enrollment/PersonalInfo";
import Address from "./app/features/screens/self_enrollment/Address";
import Eligibility from "./app/features/screens/self_enrollment/Eligibility";
import NationalVerifier from "./app/features/screens/self_enrollment/NationalVerifier";
import ResumeApplication from "./app/features/screens/self_enrollment/ResumeApplication";
// import CreateTemplate from "./app/features/screens/sms_notification/CreateTemplate";
import ManageTemplate from "./app/features/screens/sms_notification/ManageTemplate";
import ShowDraftAll from "./app/features/screens/sms_notification/ShowDraftAll";
import ShowSentAll from "./app/features/screens/sms_notification/ShowSentAll";
import Dashboard from "./app/features/screens/dashboard/Dashboard";
import LoginScreen from "./app/features/screens/auth/login_screen";
import CreateRole from "./app/features/screens/roles_and_permissions/CreateRole";
import CreateUser from "./app/features/screens/user_management/CreateUser";
import ManageUser from "./app/features/screens/user_management/ManageUser";
import EditUser from "./app/features/screens/user_management/EditUser";
import ManageDepartment from "./app/features/screens/user_management/Manage_Department";
import CreateDepartment from "./app/features/screens/user_management/CreateDepartment";
import EditDepartment from "./app/features/screens/user_management/EditDepartment";
import NotFound from "./app/features/screens/not_found/NotFound";
import ClearEsnReportFlowPage from "./app/features/screens/inventory_management/bulk_processes/clear_esn_report/clear_esn_report_flow_page";
import DeactivateMdnFlowPage from "./app/features/screens/inventory_management/bulk_processes/deactivate_mdn_report/clear_mdn_report_flow_page";
import SwapEsnReportFlowPage from "./app/features/screens/inventory_management/bulk_processes/swap_esn_report/swap_esn_report_flow_page";
import EsnSimDrawer from "./app/features/screens/inventory_management/esn_sim_drawer/esn_sim_drawer";
import InventoryReport from "./app/features/screens/inventory_management/inventory_report.js/inventory_report";
import ManageModelFlowPage from "./app/features/screens/inventory_management/manage_model/model_list";
import UploadBulk from "./app/features/screens/lifeline_orders/UploadBulk";
import ProvisioningQueueLifeline from "./app/features/screens/lifeline_orders/Provisioning_queue";
import ApprovedEnrollmentsLifeline from "./app/features/screens/lifeline_orders/Approved_Enrollments";
import Searchall from "./app/features/screens/search_customer/search_all/search_all";
import BillingConfiguration from "./app/features/screens/inventory_management/billing_configurations/BillingConfiguration";
import PrepaidInCompleteEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/incomplete_enrollments.js/incomplete";
import InvenotorySearch from "./app/features/screens/search_customer/advance_search/inventory_search/inventory_search";
import PrepaidAllEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/all_enrollments.js/all_enrollment";
import PostEnrollmentFlow from "./app/features/screens/PostPaid-order/Pages/post_enrollment_flow";
import CompletedEnrollmentsPostpaid from "./app/features/screens/PostPaid-order/PostOrder-Screens/Completed_enrollment";
import AllEnrollmentsPostpaid from "./app/features/screens/PostPaid-order/PostOrder-Screens/All_Enrollments";
import IncompletedEnrollment from "./app/features/screens/PostPaid-order/PostOrder-Screens/Incomplete_ENrollment";
import RejectedEnrollmentsPostpaid from "./app/features/screens/PostPaid-order/PostOrder-Screens/Rejected_Enrollment";
import ApprovedEnrollments from "./app/features/screens/PostPaid-order/PostOrder-Screens/Approved_Enrollment";
import PostPersonalInfo from "./app/features/screens/PostPaid-order/PersonalInfo_com/PersonalInfo";
import PostDispatchInsight from "./app/features/screens/PostPaid-order/PostOrder-Screens/Post_Dispatch_Insights";
import PrepaidRejectedEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/rejected_enrollment/rejected_enrollment";
import PrepaidApprovedEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/approved_enrollment/approved_enrollment";
import ListAllPlans from "./app/features/screens/plans_configurations/plan_list";
import PrepaidEvaluatedEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/evaluated_enrollments/Evaluated_Enrollments";
import ManageVendors from "./app/features/screens/user_management/ManageVendors/Manage_Vendors";
import AddVendors from "./app/features/screens/user_management/ManageVendors/components/Add_Vendors";
import UpdateVendors from "./app/features/screens/user_management/ManageVendors/components/Update_Vendors";
import RolesPermission from "./app/features/screens/user_management/Manage__Role_Right_Permission.js/Roles_Permission";
import LabelDownloads from "./app/features/screens/Bulk_Downloads/Label_Downloads/Label_Downloads";
import InvoicesDownloads from "./app/features/screens/Bulk_Downloads/Invoices_Downloads/Invoices_Downloads";
import InventoryDownloads from "./app/features/screens/Bulk_Downloads/Inventory_Downloads/Inventory_Downloads";
import PostpaidActivatedBulkUpload from "./app/features/screens/PostPaid-order/PostOrder-Screens/BulkActivatedUpload/Bulk_Activated_Upload";
import Reports from "./app/features/screens/Reports_Downloads/Reports";
import PrepiadSelfVerifyZip from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/VerifyZip";
import PrepaidSelfPersonalInfo from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/PersonalInfo";
import PrepaidSelfAddress from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/Address";
import PrepaidSelfEligibility from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/Eligibility";
import PrepaidSelfNationalVerifier from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/NationalVerifier";
import PrepaidSelfResumeApplication from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/ResumeApplication";
import PrepiadSelectInventory from "./app/features/screens/prepaid_postpaid_orders/self_enrollment/Select_Inventory";
import PrepaidAllSelfEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/all_Self_enrollments.js/all_enrollment";
import PrepaidCompletedEnrollments from "./app/features/screens/prepaid_postpaid_orders/prepaid_orders/components/CompletedEnrollment/Completed_enrollment";
import Porting from "./app/features/screens/Porting/Porting";
import AddServiceMain from "./app/features/screens/customer_services/Add_Service/Main_Add_Service";
import MainPrepaidUpdated from "./app/features/screens/Prepaid_Updated/Add_Service/Main_Add_Service";
import PostpaidAddServiceMain from "./app/features/screens/PostPaid-order-updated/Add_Service/Main_Add_Service";
import SendOTP from "./app/features/screens/auth/SendOTP";
import ForgotPass from "./app/features/screens/auth/ForgotPass";
import Login from "./app/features/screens/auth/Login";
import Invalid from "./app/features/screens/auth/Invalid";
import PaymentSuccess from "./app/features/screens/BankOfAmerica/PaymentSuccess/PaymentSuccess";
import PaymentFailed from "./app/features/screens/BankOfAmerica/PaymentFailed/PaymentFailed";
import { MainCustomerProfile } from "./app/features/screens/customer_profile/CustomerProfileNew/MainCustomerProfile";
import AddUnits from "./app/features/screens/inventory_management/manage-inventory/add_units/add_units_flow_page";
import BulkUpdate from "./app/features/screens/inventory_management/manage-inventory/add_units/add_units_components/bulkupdate/BulkUpdate";
import { CreateTemplate } from "./app/features/screens/Reports_Downloads/components/CreateTemplate/CreateTempate";

// ======================= App Constants =======================
const layoutColorMode = "light";
const inputStyle = "outlined";
const ripple = true;
const layoutMode = "static";
const staticMenuInactive = false;
const overlayMenuActive = false;

// ======================= Main App Component =======================
const App = () => {
  // ======================= Router & Location =======================
  let navigate = useNavigate();
  const location = useLocation();

  // ======================= State Management =======================
  const [
    refreshCustomerProfileOnNotification,
    setRefreshCustomerProfileOnNotification,
  ] = useState("");
  // eslint-disable-next-line react-hooks/exhaustive-deps
  // eslint-disable-next-line no-unused-vars
  const [refreshApp, setRefreshApp] = useState(false);
  const [isLinkedAccountIncomplete, setIsLinkedAccountIncomplete] =
    useState("");
  const [dynamicMenu, setDynamicMenu] = useState([]);
  const [callSearchApi, setCallSearchApi] = useState(false);
  const [searchByValueClick, setSearchByValueClick] = useState(false);
  let protectedRoute =
    JSON.parse(localStorage.getItem("protectedRoute")) ?? false;
  const [searchBy, setSearchBy] = useState(null);
  const [searchValue, setSearchValue] = useState("");
  const [mobileMenuActive, setMobileMenuActive] = useState(false);
  const [permittedRoutes, setPermittedRoutes] = useState([]);
  const [refreshNotificationcomponent, setRefreshNotificationComponent] =
    useState(false);
  const [refreshEsn, setRefreshEsn] = useState(false);
  const [refreshBell, setRefreshBell] = useState(false);
  const [handleHighlight, setHandleHighlight] = useState("");
  const [isPrepaidIncomplete, setIsPrepaidIncomplete] = useState("");
  const [showApps, setShowApps] = useState(false);
  const [isPostpaidIncomplete, setIsPostpaidIncomplete] = useState("");
  // eslint-disable-next-line no-unused-vars
  let [checkforbankofAmericaPayment, setCheckForBankOfAmericaPayment] =
    useState(false);

  // ======================= Menu & Permissions =======================
  const [customerServicesIndex, setCustomerServicesIndex] = useState();
  const [activeTab, setActiveTab] = useState();
  const isUserLogin = localStorage.getItem("userData");
  if (location.pathname === "/login" && isUserLogin) {
    navigate("/");
  }
  const [
    // eslint-disable-next-line no-unused-vars
    isBankOfamericaPrepaidPaymentSucceeded,
    setIsBankOfAmericaPrepaidPaymentSuceeded,
  ] = useState(false);

  // ======================= Layout Classes =======================
  const wrapperClass = classNames("layout-wrapper", {
    "layout-overlay": layoutMode === "overlay",
    "layout-static": layoutMode === "static",
    "layout-static-sidebar-inactive":
      staticMenuInactive && layoutMode === "static",
    "layout-overlay-sidebar-active":
      overlayMenuActive && layoutMode === "overlay",
    "layout-mobile-sidebar-active": mobileMenuActive,
    "p-input-filled": inputStyle === "filled",
    "p-ripple-disabled": ripple === false,
    "layout-theme-light": layoutColorMode === "light",
  });

  // ======================= Permission Fetching =======================
  const getPermissions = useCallback(() => {
    const storedPermissions = localStorage.getItem("permissions");
    if (!storedPermissions) return;
    const modules = JSON.parse(storedPermissions);
    setDynamicMenu([{ items: modules }]);
    setPermittedRoutes(modules);
  }, []);
  useEffect(() => {
    getPermissions();
  }, [getPermissions]);

  // ======================= Permission Check Helper =======================
  const isPermitted = (route) => {
    for (const mainmodule of permittedRoutes) {
      for (const submodule of mainmodule.subModules) {
        if (submodule.route === route) {
          return true;
        }
      }
    }
  };

  // ======================= Auth & Redirects =======================
  useEffect(() => {
    const userData = localStorage.getItem("userData");
    const newPermission = localStorage.getItem("newpermission");
    if (
      location.pathname === "/forgot-password" ||
      location.pathname === "/sendotp" ||
      location.pathname === "invalid-token"
    ) {
      // Do nothing for these routes
    } else if (userData === null || userData === "null") {
      navigate("/login");
    } else if (!newPermission) {
      localStorage.clear();
      navigate("/login");
    }
  }, [navigate, location.pathname]);

  // ======================= Customer Service Index Setup =======================
  useEffect(() => {
    if (!dynamicMenu[0]?.items?.length) return;
    const index = dynamicMenu[0].items.findIndex(
      (item) => item.label === "Customer Service"
    );
    if (index !== -1 && customerServicesIndex === undefined) {
      setCustomerServicesIndex(index);
    }
  }, [dynamicMenu, customerServicesIndex]);

  // ======================= Menu Toggle Handler =======================
  const onToggleMenuClick = (event) => {
    event.stopPropagation();
    setMobileMenuActive((prevState) => !prevState);
    event.preventDefault();
  };

  // ======================= Render =======================
  return (
    <div>
      {protectedRoute ? (
        <div className={wrapperClass}>
          {/* ======================= Topbar ======================= */}
          <AppTopbar
            setRefreshOnNotification={setRefreshCustomerProfileOnNotification}
            searchBy={searchBy}
            model={dynamicMenu}
            searchValue={searchValue}
            setSearchBy={setSearchBy}
            setSearchByValueClick={setSearchByValueClick}
            setSearchValue={setSearchValue}
            searchByValueClick={searchByValueClick}
            setCallSearchApi={setCallSearchApi}
            onToggleMenuClick={onToggleMenuClick}
            layoutColorMode={layoutColorMode}
            setRefreshNotificationComponent={setRefreshNotificationComponent}
            refreshBell={refreshBell}
            showApps={showApps}
            setShowApps={setShowApps}
            setHandleHighlight={setHandleHighlight}
            style={{ boxShadow: "none !important" }}
          />

          {/* ======================= Sidebar ======================= */}
          <div className="layout-sidebar">
            <AppMenu
              setMobileMenuActive={setMobileMenuActive}
              setSearchByValueClick={setSearchByValueClick}
              setSearchBy={setSearchBy}
              model={dynamicMenu}
              activeTab={activeTab}
              setDynamicMenu={setDynamicMenu}
              setCallSearchApi={setCallSearchApi}
              searchByValueClick={searchByValueClick}
              layoutColorMode={layoutColorMode}
            />
          </div>

          {/* ======================= Main Content ======================= */}
          <div className="flex flex-wrap flex-row content-main-container justify-content-center">
            <div className="layout-main-container">
              <div className="layout-main">
                {/* ======================= Search & Main Routes ======================= */}
                {searchBy || searchByValueClick ? (
                  // ...search logic and components...
                  searchByValueClick ? (
                    <Searchall
                      setSearchByValueClick={setSearchByValueClick}
                      callSearchApi={callSearchApi}
                      searchValue={searchValue}
                      setSearchBy={setSearchBy}
                    />
                  ) : searchBy.code === "advance search" ? (
                    <AdvanceSearch setSearchBy={setSearchBy} />
                  ) : searchBy.code === "inventorysearch" ? (
                    <h1>
                      <InvenotorySearch />
                    </h1>
                  ) : (
                    <div className="card searchby flex flex-row flex-wrap justify-content-around align-items-center">
                      <div>
                        <h1 className="text-center w-full ">{searchBy.name}</h1>
                        <h5 className="text-center w-full mt-4 ">
                          Get Ready! We are working on something really cool.
                        </h5>
                      </div>
                    </div>
                  )
                ) : (
                  <>
                    {/* ======================= Protected Routes ======================= */}
                    {permittedRoutes.length !== 0 && (
                      <Routes>
                        <Route path="*" element={<NotFound />} />
                        <Route
                          path="/"
                          element={
                            <Dashboard permittedRoutes={permittedRoutes} />
                          }
                        />
                        <Route
                          path="/shipping-queues"
                          element={
                            isPermitted("/shipping-queues") ? (
                              <ShippingQueue />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/bulkprocesses/bulk-clear-device"
                          element={
                            isPermitted("/bulkprocesses") ? (
                              <ClearDeviceReportFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/bulkprocesses/bulk-clear-esn"
                          element={
                            isPermitted("/bulkprocesses") ? (
                              <ClearEsnReportFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/plan-configurations"
                          element={
                            isPermitted("/plan-configurations") ? (
                              <ListAllPlans />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-newenrollment"
                          element={
                            isPermitted("/prepaid-newenrollment") ? (
                              <MainPrepaidUpdated
                                key={Date.now()}
                                isPrepaidIncomplete={isPrepaidIncomplete}
                                setIsPrepaidIncomplete={setIsPrepaidIncomplete}
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-completeenrollments"
                          element={
                            isPermitted("/prepaid-completeenrollments") ? (
                              <PrepaidCompletedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/bulkprocesses/bulk-deactivate-mdn"
                          element={
                            isPermitted("/bulkprocesses") ? (
                              <DeactivateMdnFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/bulkprocesses/bulk-swap-esn"
                          element={
                            isPermitted("/bulkprocesses") ? (
                              <SwapEsnReportFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/add-service"
                          element={
                            isPermitted("/add-service") ? (
                              <AddServiceMain
                                key={Date.now()}
                                isLinkedAccountIncomplete={
                                  isLinkedAccountIncomplete
                                }
                                setIsLinkedAccountIncomplete={
                                  setIsLinkedAccountIncomplete
                                }
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/manage-model"
                          element={
                            isPermitted("/manage-model") ? (
                              <ManageModelFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/manageinventory"
                          element={
                            isPermitted("/manageinventory") ? (
                              <ManageInventory isPermitted={isPermitted} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/esn-sim-drawer"
                          element={
                            isPermitted("/esn-sim-drawer") ? (
                              <EsnSimDrawer />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/dropshiporders"
                          element={
                            isPermitted("/dropshiporders") ? (
                              <DropshipOrdersFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/inventory-report"
                          element={
                            isPermitted("/inventory-report") ? (
                              <InventoryReport />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/companyacpprograms"
                          element={
                            isPermitted("/companyacpprograms") ? (
                              <AcpProgramsFlowPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/newenrolment"
                          element={
                            isPermitted("/newenrolment") ? (
                              <ServiceAvailablityPage />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        {/* <Route path="/enrollment" element={isPermitted("/enrollment") ? <EnrollmentFlowPage /> : <Dashboard />} /> */}
                        <Route
                          path="/postpaid-evaluatedenrollments"
                          element={
                            isPermitted("/postpaid-evaluatedenrollments") ? (
                              <PostpaidEvaluatedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-evaluatedenrollments"
                          element={
                            isPermitted("/prepaid-evaluatedenrollments") ? (
                              <PrepaidEvaluatedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/enrollment"
                          element={<EnrollmentFlowPage />}
                        />
                        <Route
                          path="/post-enrollment"
                          element={
                            <PostEnrollmentFlow
                              isPostpaidIncomplete={isPostpaidIncomplete}
                              setIsPostpaidIncomplete={setIsPostpaidIncomplete}
                            />
                          }
                        />
                        <Route
                          path="/managerolesandrights/*"
                          element={
                            isPermitted("/managerolesandrights") ? (
                              <ManageRolesAndRights />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/all-enrollments"
                          element={
                            isPermitted("/all-enrollments") ? (
                              <AllEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/bulk-upload"
                          element={
                            isPermitted("/bulk-upload") ? (
                              <UploadBulk />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/completedenrollments"
                          element={
                            isPermitted("/completedenrollments") ? (
                              <CompletedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/incompleteenrollments"
                          element={
                            isPermitted("/incompleteenrollments") ? (
                              <InCompletedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/rejectedenrollments"
                          element={
                            isPermitted("/rejectedenrollments") ? (
                              <RejectedEnrollmentsPostpaid />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-incompleteenrollment"
                          element={
                            isPermitted("/prepaid-incompleteenrollment") ? (
                              <PrepaidInCompleteEnrollments
                                isPrepaidIncomplete={isPrepaidIncomplete}
                                setIsPrepaidIncomplete={setIsPrepaidIncomplete}
                                isLinkedAccountIncomplete={
                                  isLinkedAccountIncomplete
                                }
                                setIsLinkedAccountIncomplete={
                                  setIsLinkedAccountIncomplete
                                }
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/nladresolutionstatus"
                          element={
                            isPermitted("/nladresolutionstatus") ? (
                              <NLADResolutionStatus />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/handovereventorder"
                          element={
                            isPermitted("/handovereventorder") ? (
                              <HandoverEventOrder />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/pendingeventorder"
                          element={
                            isPermitted("/pendingeventorder") ? (
                              <PendingEventOrder />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/withoutproofenrollments"
                          element={
                            isPermitted("/withoutproofenrollments") ? (
                              <WithoutProofEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/withproofenrollments"
                          element={
                            isPermitted("/withproofenrollments") ? (
                              <WithProofEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-rejectedenrollment"
                          element={
                            isPermitted("/prepaid-rejectedenrollment") ? (
                              <PrepaidRejectedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-approvedenrollment"
                          element={
                            isPermitted("/prepaid-approvedenrollment") ? (
                              <PrepaidApprovedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-allenrollment"
                          element={
                            isPermitted("/prepaid-allenrollment") ? (
                              <PrepaidAllEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/smsnotification"
                          element={
                            isPermitted("/smsnotification") ? (
                              <Upload />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/sent"
                          element={
                            isPermitted("/sent") ? <Sent /> : <Dashboard />
                          }
                        />
                        <Route
                          path="/draft"
                          element={
                            isPermitted("/draft") ? <Draft /> : <Dashboard />
                          }
                        />
                        <Route
                          path="/postpaid-activated-bulkupload"
                          element={
                            isPermitted("/postpaid-activated-bulkupload") ? (
                              <PostpaidActivatedBulkUpload />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/provisioning-queue"
                          element={
                            isPermitted("/provisioning-queue") ? (
                              <ProvisioningQueueLifeline />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/approved-enrollments"
                          element={
                            isPermitted("/approved-enrollments") ? (
                              <ApprovedEnrollmentsLifeline />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/billing-model-configuration"
                          element={<BillingModelConfigurations />}
                        />
                        <Route
                          path="/draftall/:id"
                          element={<ShowDraftAll />}
                        />
                        <Route path="/sentall/:id" element={<ShowSentAll />} />
                        <Route
                          path="/selfenrollment"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <VerifyZip />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/personalinfo"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <PersonalInfo />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/selfaddress"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <Address />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/selfeligibile"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <Eligibility />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/nationalverifier"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <NationalVerifier />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/resumeapplication"
                          element={
                            isPermitted("/selfenrollment") ? (
                              <ResumeApplication />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/new-selfenrollment"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepiadSelfVerifyZip />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selectinventory"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepiadSelectInventory />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selfpersonalinfo"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepaidSelfPersonalInfo />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selfaddress"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepaidSelfAddress />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selfeligibile"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepaidSelfEligibility />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selfnationalverifier"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepaidSelfNationalVerifier />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/prepaid-selfresumeapplication"
                          element={
                            isPermitted("/new-selfenrollment") ? (
                              <PrepaidSelfResumeApplication />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/all-selfenrollment"
                          element={
                            isPermitted("/all-selfenrollment") ? (
                              <PrepaidAllSelfEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />

                        <Route
                          path="/createtemplate"
                          element={
                            isPermitted("/createtemplate") ? (
                              <CreateTemplate />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/managetemplate/*"
                          element={
                            isPermitted("/managetemplate") ? (
                              <ManageTemplate />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/createrole"
                          element={
                            isPermitted("/createrole") ? (
                              <CreateRole />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="/add-unit"
                          element={
                            isPermitted("/add-unit") ? (
                              <AddUnits isFromhome={true} isUpload={true} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="/bulk-update"
                          element={
                            isPermitted("/bulk-update") ? (
                              <BulkUpdate isFromhome={true} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/manage-user"
                          element={
                            isPermitted("/manage-user") ? (
                              <ManageUser isPermitted={isPermitted} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/roles-permissions"
                          element={
                            isPermitted("/roles-permissions") ? (
                              <RolesPermission />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/add-user"
                          element={
                            isPermitted("/add-user") ? (
                              <CreateUser isFromhome={true} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/create-template"
                          element={
                            isPermitted("/create-template") ? (
                              <CreateTemplate isFromhome={true} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/edit-user"
                          element={
                            isPermitted("/edit-user") ? (
                              <EditUser />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/manage-department"
                          element={
                            isPermitted("/manage-department") ? (
                              <ManageDepartment />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/edit-department"
                          element={
                            isPermitted("/edit-department") ? (
                              <EditDepartment />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/manage-vendors"
                          element={
                            isPermitted("/manage-vendors") ? (
                              <ManageVendors />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="/add_vendors"
                          element={<AddVendors />}
                        />
                        <Route
                          exact
                          path="/update_vendors"
                          element={<UpdateVendors />}
                        />
                        <Route
                          path="/create-department"
                          element={
                            isPermitted("/create-department") ? (
                              <CreateDepartment />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/Porting"
                          element={
                            isPermitted("/Porting") ? (
                              <Porting />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="/customer-profile"
                          element={
                            isPermitted("/customer-profile") ? (
                              <MainCustomerProfile
                                activeTab={activeTab}
                                refreshOnNotification={
                                  refreshCustomerProfileOnNotification
                                }
                                setRefreshOnNotification={
                                  setRefreshCustomerProfileOnNotification
                                }
                                model={dynamicMenu}
                                customerServicesIndex={customerServicesIndex}
                                setActiveTab={setActiveTab}
                                refreshNotificationcomponent={
                                  refreshNotificationcomponent
                                }
                                refreshEsn={refreshEsn}
                                setRefreshEsn={setRefreshEsn}
                                setRefreshBell={setRefreshBell}
                                handleHighlight={handleHighlight}
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />

                        <Route
                          exact
                          path="/billingconfiguration"
                          element={
                            isPermitted("/billingconfiguration") ? (
                              <BillingConfiguration />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-newenrollment"
                          element={
                            isPermitted("/postpaid-newenrollment") ? (
                              <PostpaidAddServiceMain
                                key={Date.now()}
                                isPostpaidIncomplete={isPostpaidIncomplete}
                                setIsPostpaidIncomplete={
                                  setIsPostpaidIncomplete
                                }
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-complete"
                          element={
                            isPermitted("/postpaid-complete") ? (
                              <CompletedEnrollmentsPostpaid />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-allenrollment"
                          element={
                            isPermitted("/postpaid-allenrollment") ? (
                              <AllEnrollmentsPostpaid />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-incomplete"
                          element={
                            isPermitted("/postpaid-incomplete") ? (
                              <IncompletedEnrollment
                                isPostpaidIncomplete={isPostpaidIncomplete}
                                setIsPostpaidIncomplete={
                                  setIsPostpaidIncomplete
                                }
                                isLinkedAccountIncomplete={
                                  isLinkedAccountIncomplete
                                }
                                setIsLinkedAccountIncomplete={
                                  setIsLinkedAccountIncomplete
                                }
                              />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-rejectedenrollment"
                          element={
                            isPermitted("/postpaid-rejectedenrollment") ? (
                              <RejectedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-approvedenrollment"
                          element={
                            isPermitted("/postpaid-approvedenrollment") ? (
                              <ApprovedEnrollments />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          exact
                          path="postpaid-dispatchinsight"
                          element={
                            isPermitted("/postpaid-dispatchinsight") ? (
                              <PostDispatchInsight />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/Postpersonalinfo"
                          element={<PostPersonalInfo />}
                        />
                        <Route
                          path="/roles-permissions"
                          element={<RolesPermission />}
                        />
                        {/* handling Bulk Downloads Routes */}
                        <Route
                          path="/label-downloads"
                          element={
                            isPermitted("/label-downloads") ? (
                              <LabelDownloads />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/invoices-downloads"
                          element={
                            isPermitted("/invoices-downloads") ? (
                              <InvoicesDownloads />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/inventory-downloads"
                          element={
                            isPermitted("/inventory-downloads") ? (
                              <InventoryDownloads />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/Payment-Success"
                          element={
                            <PaymentSuccess
                              setIsBankOfAmericaPrepaidPaymentSuceeded={
                                setIsBankOfAmericaPrepaidPaymentSuceeded
                              }
                              setCheckForBankOfAmericaPayment={
                                setCheckForBankOfAmericaPayment
                              }
                            />
                          }
                        />
                        <Route
                          path="/Payment-Failure"
                          element={
                            <PaymentFailed
                              setIsBankOfAmericaPrepaidPaymentSuceeded={
                                setIsBankOfAmericaPrepaidPaymentSuceeded
                              }
                              setCheckForBankOfAmericaPayment={
                                setCheckForBankOfAmericaPayment
                              }
                            />
                          }
                        />

                        <Route
                          path="/reports-downloads"
                          element={
                            isPermitted("/reports-downloads") ? (
                              <Reports isPermitted={isPermitted} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                        <Route
                          path="/add-role"
                          element={
                            isPermitted("/add-role") ? (
                              <CreateRole isFromhome={true} />
                            ) : (
                              <Dashboard />
                            )
                          }
                        />
                      </Routes>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      ) : (
        // ======================= Auth Routes =======================
        <Routes>
          <Route
            path="/login"
            element={
              <LoginScreen
                setShowApps={setShowApps}
                setDynamicMenu={setDynamicMenu}
                setPermittedRoutes={setPermittedRoutes}
                setRefreshApp={setRefreshApp}
              />
            }
          />
          <Route path="/sendotp" element={<SendOTP />} />
          <Route path="/loginpage" element={<Login />} />
          <Route path="/invalid-token" element={<Invalid />} />
          <Route
            path="/forgot-password"
            element={<ForgotPass />}
          />
          <Route path="/selfenrollment" element={<VerifyZip />} />
          <Route path="/personalinfo" element={<PersonalInfo />} />
          <Route path="/selfaddress" element={<Address />} />
          <Route path="/selfeligibile" element={<Eligibility />} />
          <Route path="/nationalverifier" element={<NationalVerifier />} />
          <Route path="/resumeapplication" element={<ResumeApplication />} />
        </Routes>
      )}
    </div>
  );
};

export default App;
// useEffect(() => {
//     // console.log("window location is", window.location);
//     // if (window.location.hash === "#/") {
//     //     if (sessionStorage.getItem("Payment Initiation") === "Prepaid Enrollment") {
//     //         api.get(`/api/user/userDetails?userId=${sessionStorage.getItem("userId")}`)
//     //             .then((res) => {
//     //                 console.log("response is", { ...res?.data?.data, bankOfamericacustomer: true, paymentStatus: true });
//     //                 setIsPrepaidIncomplete({ ...res?.data?.data, bankOfamericacustomer: true, paymentStatus: isBankOfamericaPrepaidPaymentSucceeded });
//     //                 setTimeout(() => {
//     //                     navigate("/prepaid-newenrollment");
//     //                     console.log(isPrepaidIncomplete);
//     //                 }, 500);
//     //             })
//     //             .catch((err) => {});
//     //         //  setUserData1(res?.data?.data);
//     //     }
//     //     console.log(sessionStorage.getItem("Payment Initiation"));
//     // }
// }, [checkforbankofAmericaPayment]);
